<div class="content">
    <!-- ID Rec Selection Modal -->
    <div class="id-rec-modal-overlay" *ngIf="showIdRecModal" (click)="closeIdRecModal()">
        <div class="id-rec-modal-content" (click)="$event.stopPropagation()">
            <div class="modal-header">
                <h2>Select Wellbore Scheme ID Rec</h2>
                <p class="modal-subtitle">Choose the ID Rec configuration for <strong>{{ selectedWellForIdRec?.name || selectedWellForIdRec }}</strong></p>
                <button class="modal-close-btn" (click)="closeIdRecModal()">
                    <span class="material-icons">close</span>
                </button>
            </div>
            
            <div class="id-rec-cards-container">
                <!-- Loading State -->
                <div class="loading-state" *ngIf="loadingIdRec">
                    <div class="spinner"></div>
                    <p>Loading wellbore schemes...</p>
                </div>
                
                <!-- No Data State -->
                <div class="no-data-state" *ngIf="!loadingIdRec && idRecOptions.length === 0">
                    <span class="material-icons">info</span>
                    <p>No wellbore schemes available for this well</p>
                </div>
                
                <!-- ID Rec Cards -->
                <div class="id-rec-card" 
                     *ngFor="let idRec of idRecOptions"
                     [class.selected]="selectedIdRec?.id === idRec.id"
                     (click)="selectIdRec(idRec)">
                    <div class="card-icon">
                        <span class="material-icons">place</span>
                    </div>
                    <h3 class="card-title">{{ idRec.name }}</h3>
                    <p class="card-description">{{ idRec.description }}</p>
                    <p class="card-id">ID Rec: <span>{{ idRec.id }}</span></p>
                    <div class="card-checkmark" *ngIf="selectedIdRec?.id === idRec.id">
                        <span class="material-icons">check_circle</span>
                    </div>
                </div>
            </div>
            
            <div class="modal-footer">
                <button class="btn btn-cancel" (click)="closeIdRecModal()">Cancel</button>
                <button class="btn btn-proceed" 
                        [disabled]="!selectedIdRec"
                        (click)="proceedWithIdRec()">
                    Proceed
                </button>
            </div>
        </div>
    </div>

    <!-- Upload Type Selection Modal -->
    <div class="upload-type-modal-overlay" *ngIf="showUploadTypeModal" (click)="closeUploadTypeModal()">
        <div class="upload-type-modal-content" (click)="$event.stopPropagation()">
            <div class="modal-header">
                <h2>Select Upload Type</h2>
                <p class="modal-subtitle">Choose the type of file you want to upload</p>
                <button class="modal-close-btn" (click)="closeUploadTypeModal()">
                    <span class="material-icons">close</span>
                </button>
            </div>
            
            <div class="upload-type-cards-container">
                <!-- Raw File Upload Card -->
                <div class="upload-type-card" 
                     [class.selected]="selectedUploadType === 'raw'"
                     (click)="selectUploadType('raw')">
                    <div class="card-icon">
                        <span class="material-icons">folder_zip</span>
                    </div>
                    <h3 class="card-title">Raw File Upload</h3>
                    <p class="card-description">Upload Raw Data Files</p>
                    <p class="card-format">Format: .zip</p>
                    <div class="card-checkmark" *ngIf="selectedUploadType === 'raw'">
                        <span class="material-icons">check_circle</span>
                    </div>
                </div>
                
                <!-- Excel File Upload Card -->
                <div class="upload-type-card" 
                     [class.selected]="selectedUploadType === 'excel'"
                     (click)="selectUploadType('excel')">
                    <div class="card-icon">
                        <span class="material-icons">upload_file</span>
                    </div>
                    <h3 class="card-title">Excel Upload</h3>
                    <p class="card-description">Upload Excel Spreadsheets</p>
                    <p class="card-format">Format: .xls, .xlsx</p>
                    <div class="card-checkmark" *ngIf="selectedUploadType === 'excel'">
                        <span class="material-icons">check_circle</span>
                    </div>
                </div>
            </div>
            
            <div class="modal-footer">
                <button class="btn btn-cancel" (click)="closeUploadTypeModal()">Cancel</button>
                <button class="btn btn-proceed" 
                        [disabled]="!selectedUploadType"
                        (click)="proceedWithUploadType()">
                    Proceed
                </button>
            </div>
        </div>
    </div>

    <!-- Upload Page View -->
    <div class="upload-page" *ngIf="showUploadModal || router.url === '/upload'">
        <app-bulk-upload 
            [isUploading]="isUploading"
            [uploadType]="(tabNavigationService.selectedUploadType$ | async) || 'excel'"
            (fileSelected)="onFileSelected($event)" 
            (backRequested)="closeUploadModal(); router.navigate(['/wells'])">
        </app-bulk-upload>
    </div>

    <!-- Main Wells/Requests View -->
    <div class="main-view" *ngIf="!showUploadModal">
        <div class="wells-section" *ngIf="isAuthenticated || tableLoading">
            <div class="section-header">

                <div class="wells-action-buttons">
                    <!-- Tabs Navigation -->
                    <div class="tabs-container">
                        <div class="well-header-row">
                            <div class="well-title">
                                <h3>Wells Overview</h3>
                            </div>
                        </div>
                        <!-- <button class="tab-button" 
                                [class.active]="activeTab === 'wells'" 
                                (click)="switchTab('wells')">
                            <img src="/assets/cvx_oil-rig_icon_RGB_FA.png" alt="Wells" class="tab-icon-img" width="20" height="20">
                            Wells
                        </button> -->
                        <!-- <button class="tab-button" 
                                [class.active]="activeTab === 'requests'" 
                                (click)="switchTab('requests')">
                            <span class="icon">assignment</span>
                            Requests
                        </button> -->
                    </div>
                    <div class="action-buttons">
                        <div class="search-container">
                            <span class="search-icon material-icons">search</span>
                            <span class="search-icon material-icons">search</span>
                            <input 
                                type="text" 
                                class="search-input" 
                                placeholder="Search wells or requests..." 
                                [(ngModel)]="wellSearchQuery"
                                (input)="searchWells()">
                            <button class="clear-button icon-only" *ngIf="wellSearchQuery" (click)="clearSearch()" title="Clear search">
                                ✖
                            </button>
                        </div>
                        <button class="btn btn-refresh" (click)="loadWells()" [disabled]="loading || tableLoading">
                            <span class="material-icons">refresh</span>
                            Refresh
                        </button>
                    </div>
                </div>
            </div>
            
            <!-- Wells/Requests Table Card -->
            <div class="wells-table-card" [class.requests-view]="activeTab === 'requests'">
                <div class="table-wrapper" [class.loading-active]="tableLoading && activeTab === 'wells'">
                    <div class="loading table-overlay" *ngIf="tableLoading && activeTab === 'wells'">
                        <div class="spinner"></div>
                        <p>Loading wells...</p>
                    </div>
                    <table class="wells-table">
                        <thead>
                            <tr *ngIf="activeTab === 'wells'">
                                <th>Name</th>
                                <th>Schemas</th>
                                <th>Stages Completed</th>
                                <th (click)="sortByColumn('last_updated')" style="cursor: pointer;">
                                    Last Updated {{ getSortIndicator('last_updated') }}
                                </th>
                            </tr>
                            <tr *ngIf="activeTab === 'requests'">
                                <th>Name</th>
                                <th>Date</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Wells Table Rows -->
                            <ng-container *ngIf="activeTab === 'wells'">
                                <tr *ngIf="!tableLoading && paginatedWells.length === 0">
                                    <td colspan="4" class="no-data">
                                        <div class="no-data-content">
                                            <span class="no-data-icon">🔍</span>
                                            <p>No wells found</p>
                                            <p class="no-data-hint" *ngIf="wellSearchQuery">Try adjusting your search criteria</p>
                                            <p class="no-data-hint" *ngIf="!wellSearchQuery">No wells available</p>
                                        </div>
                                    </td>
                                </tr>
                                <tr *ngFor="let well of paginatedWells" 
                                    (click)="onWellSelect(well)">
                                    <td class="well-name">{{ well.well_id }}</td>
                                    <td class="schemas-cell">
                                        <div class="schemas-header">
                                            <div class="schemas-container">
                                                <span class="schemas-count">{{ well.schemas }}</span>
                                                <button class="expand-btn" 
                                                        (click)="toggleSchemas(well, $event)"
                                                        [class.expanded]="isSchemaExpanded(well.well_id)"
                                                        title="View schemas">
                                                    <span class="material-icons">{{ isSchemaExpanded(well.well_id) ? 'expand_more' : 'chevron_right' }}</span>
                                                </button>
                                            </div>
                                        </div>
                                        
                                        <!-- Expandable Schema List (inline) -->
                                        <div class="schema-expansion" *ngIf="isSchemaExpanded(well.well_id)">
                                            <!-- Loading State -->
                                            <div class="schema-loading" *ngIf="isSchemasLoading(well.well_id)">
                                                <div class="spinner-small"></div>
                                                <span>Loading...</span>
                                            </div>
                                            
                                            <!-- Schema List -->
                                            <div class="schema-list" *ngIf="!isSchemasLoading(well.well_id) && getSchemasForWell(well.well_id).length > 0">
                                                <div class="schema-capsule" *ngFor="let schema of getSchemasForWell(well.well_id)">
                                                    {{ getSchemaName(schema) }}
                                                </div>
                                            </div>
                                            
                                            <!-- No Schemas State -->
                                            <div class="no-schemas" *ngIf="!isSchemasLoading(well.well_id) && getSchemasForWell(well.well_id).length === 0">
                                                <span class="material-icons">info</span>
                                                <span>No schemas</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="stages-cell">
                                        <div class="stages-header">
                                            <div class="stages-container">
                                                <span class="stages-count">{{ getStagesCount(well.stages_completed) }}</span>
                                                <button class="expand-btn" 
                                                        (click)="toggleStages(well, $event)"
                                                        [class.expanded]="isStagesExpanded(well.well_id)"
                                                        title="View stages">
                                                    <span class="material-icons">{{ isStagesExpanded(well.well_id) ? 'expand_more' : 'chevron_right' }}</span>
                                                </button>
                                            </div>
                                        </div>
                                        
                                        <!-- Expandable Stages List (inline) -->
                                        <div class="stages-expansion" *ngIf="isStagesExpanded(well.well_id)">
                                            <!-- No Stages / Pending State -->
                                            <div class="pending-state" *ngIf="isStagesPending(well.stages_completed)">
                                                <span class="pending-badge">Pending</span>
                                            </div>
                                            
                                            <!-- Stages List -->
                                            <div class="stages-list" *ngIf="!isStagesPending(well.stages_completed)">
                                                <div class="stage-capsule" *ngFor="let stage of getStagesArray(well.stages_completed)">
                                                    {{ stage }}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{{ formatDate(well.last_updated) }}</td>
                                </tr>
                            </ng-container>
                            
                            <!-- Requests Table Rows -->
                            <ng-container *ngIf="activeTab === 'requests'">
                                <tr *ngIf="requests.length === 0">
                                    <td colspan="4" class="no-data">
                                        <div class="no-data-content">
                                            <span class="no-data-icon">📋</span>
                                            <p>No requests to show</p>
                                            <p class="no-data-hint">Requests will appear here when available</p>
                                        </div>
                                    </td>
                                </tr>
                                <tr *ngFor="let request of paginatedRequests">
                                    <td class="request-name">{{ request.name }}</td>
                                    <td>{{ request.date }}</td>
                                    <td>
                                        <span class="status-badge" [ngClass]="request.statusClass">
                                            {{ request.status }}
                                        </span>
                                    </td>
                                    <td>
                                        <button class="action-btn">{{ request.action }}</button>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
                
                <!-- Pagination Controls -->
                <div class="pagination-container" *ngIf="activeTab === 'wells' || (activeTab === 'requests' && requests.length > 0)">
                    <div class="pagination-left">
                        <span class="rows-label">Rows per page:</span>
                        <div class="page-size-wrapper">
                            <select class="page-size-select" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
                                <option [value]="10">10</option>
                                <option [value]="20">20</option>
                                <option [value]="50">50</option>
                                <option [value]="100">100</option>
                            </select>
                            <span class="dropdown-icon material-icons">expand_more</span>
                        </div>
                    </div>
                    
                    <div class="pagination-center">
                        <span class="page-info" *ngIf="activeTab === 'wells'">{{ (currentPage - 1) * pageSize + 1 }}–{{ Math.min(currentPage * pageSize, totalItems) }} of {{ totalItems }}</span>
                        <span class="page-info" *ngIf="activeTab === 'requests'">{{ (currentPage - 1) * pageSize + 1 }}–{{ Math.min(currentPage * pageSize, requests.length) }} of {{ requests.length }}</span>
                    </div>
                    
                    <div class="pagination-right">
                        <button class="nav-btn" [disabled]="currentPage === 1 || loading || tableLoading" (click)="goToPage(1)" title="First page">
                            <span class="icon">«</span>
                        </button>
                        <button class="nav-btn" [disabled]="currentPage === 1 || loading || tableLoading" (click)="prevPage()" title="Previous page">
                            <span class="icon">‹</span>
                        </button>
                        <button class="nav-btn" [disabled]="currentPage === totalPages || loading || tableLoading" (click)="nextPage()" title="Next page">
                            <span class="icon">›</span>
                        </button>
                        <button class="nav-btn" [disabled]="currentPage === totalPages || loading || tableLoading" (click)="goToPage(totalPages)" title="Last page">
                            <span class="icon">»</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="auth-section" *ngIf="!isAuthenticated && !loading && !tableLoading">
            <div class="auth-message">
                <h3>Wells API Authentication Required</h3>
                <p>Click the button below to authenticate and load wells data.</p>
                <button class="btn btn-primary btn-large" (click)="loadWells()">
                    Load Wells & Authenticate
                </button>
            </div>
        </div>
    </div>

    <!-- Snackbar Notification -->
    <div class="snackbar" 
         *ngIf="error" 
         [class.success]="notificationType === 'success'"
         [class.error]="notificationType === 'error'"
         [class.info]="notificationType === 'info'">
        <span class="snackbar-icon material-icons" *ngIf="notificationType === 'success'">check_circle</span>
        <span class="snackbar-icon material-icons" *ngIf="notificationType === 'error'">error</span>
        <span class="snackbar-icon material-icons" *ngIf="notificationType === 'info'">info</span>
        <span class="snackbar-message">{{ error }}</span>
        <button class="snackbar-close" (click)="error = ''">
            <span class="material-icons">close</span>
        </button>
    </div>
</div>
